import { render } from "./MenuCarrousel.vue?vue&type=template&id=9c32e596"
import script from "./MenuCarrousel.vue?vue&type=script&lang=js"
export * from "./MenuCarrousel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__